import { ArrowRight01Icon, ArrowDown01Icon, Menu01Icon, Notification02Icon, UserIcon, Logout01Icon, SidebarRightIcon } from 'hugeicons-react';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import api, { API_URL } from '../../api';
import toast from 'react-hot-toast';
import Cookies from 'js-cookie';
import { hasRole } from '../../services/userPosition';

import { useGlobalData } from '../../services/GlobalDataContext';

const DashboardHeader = ({ setMobileMenuOpen, pageTitle, sidebarCollapsed, setSidebarCollapsed }) => {
    const { userProfile, unreadCount, refreshData } = useGlobalData();
    const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);

    // Derived state from context
    const fullName = userProfile ? `${userProfile.first_name} ${userProfile.last_name}` : '';
    const position = userProfile?.position || '';
    const profileImage = userProfile?.profile_image || '';
    const profileData = userProfile || {};

    const { userId } = useParams();
    const navigate = useNavigate();
    const path = window.location.pathname;
    const breadcrumbs = path.split('/').filter(Boolean);

    const handleLogout = (e) => {
        if (e) e.preventDefault();
        Cookies.remove('accessToken');
        Cookies.remove('refreshToken');
        localStorage.clear();

        const redirectUrl = process.env.NODE_ENV === 'development'
            ? 'http://localhost:3000/login'
            : `${process.env.REACT_APP_DOMAIN_NAME || ''}/login`;
        window.location.href = redirectUrl;
    };

    const breadcrumbLinks = breadcrumbs.map((breadcrumb, index) => {
        const to = '/' + breadcrumbs.slice(0, index + 1).join('/');

        let displayText = breadcrumb;
        if (breadcrumb.toLowerCase() === 'positions') {
            displayText = 'Roles & Permissions';
        } else if (!isNaN(breadcrumb)) {
            displayText = 'Details';
        } else {
            displayText = breadcrumb.charAt(0).toUpperCase() + breadcrumb.slice(1);
        }

        return (
            <span key={index} className='breadcrumb'>
                {index > 0 && <ArrowRight01Icon size={20} />}
                <Link to={to}>{displayText}</Link>
            </span>
        );
    });

    // Update unread count when navigating to notifications page
    useEffect(() => {
        if (path.includes('/notifications/') && hasRole(['Admin', 'Super User'])) {
            refreshData();
        }
    }, [path]);


    return (
        <div className='dashboard-header'>
            <div className="header-content">
                <div className="breadcrumbs">
                    <div className='menu-title'>
                        <Menu01Icon size={32} role="button" tabIndex="0" className='openMenu' onClick={() => setMobileMenuOpen(true)} />
                        <button
                            className={`sidebar-collapse-btn ${sidebarCollapsed ? 'collapsed' : ''}`}
                            onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
                            aria-label={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
                            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
                        >
                            <SidebarRightIcon
                                size={32}
                                className={`sidebar-collapse-icon ${sidebarCollapsed ? 'collapsed' : ''}`}
                            />
                        </button>

                        <h4 className="page-title">{pageTitle}</h4>
                    </div>
                    <div className="breadcrumb-list">
                        <span className='breadcrumb'>
                            <Link to="/">Dashboard / </Link>
                        </span>
                        {breadcrumbLinks}
                    </div>
                </div>

                <div className="profile-and-links">

                    {
                        hasRole(['Admin', 'Super User']) && (
                            <div className="notification">
                                <Link to={`/notifications/`}>
                                    {unreadCount > 0 && (
                                        <>
                                            <div className="dot"></div>
                                            <span className="unread-count">{unreadCount}</span>
                                        </>
                                    )}
                                    <Notification02Icon />
                                </Link>
                            </div>

                        )
                    }

                    <div className="profile" onClick={() => setIsProfileMenuOpen(!isProfileMenuOpen)} role="button" tabIndex="0">
                        {profileData && profileData.image
                            ? <img src={profileData.image} alt={profileData.name} />
                            : <img src="/logo.png" alt="" className="logo" />
                        }
                        <ArrowDown01Icon size={24} color={"#000000"} variant={"stroke"} />
                    </div>

                    {isProfileMenuOpen && (
                        <>
                            <div className='profile-overlay' onClick={() => setIsProfileMenuOpen(false)}></div>

                            <div className='profile-drop-down'>
                                <div className="profile-name">
                                    <img src={profileImage || '/favicon.ico'} alt="" />
                                    <div className='name-position'>
                                        <p>{fullName}</p>
                                        <p>{position || 'N/A'} </p>
                                    </div>
                                </div>
                                <div className="profile-menu">
                                    <div className="profile-item">
                                        <UserIcon size={24} color={"#000000"} variant={"stroke"} />
                                        <Link to='/account/'>My Profile</Link>
                                    </div>
                                    <div className="profile-item" onClick={handleLogout} style={{ cursor: 'pointer' }} role="button" tabIndex="0">
                                        <Logout01Icon size={24} color={"#000000"} variant={"stroke"} />
                                        <span>Logout</span>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}


                </div>
            </div>
        </div>
    );
}

export default DashboardHeader;
